import { PartialStoryFn, StoryContext } from '@storybook/addons';
import { html } from 'lit-html';
import { ifDefined } from 'lit-html/directives/if-defined';
import { Switch } from '../switch';

export const meta = {
  argTypes: {
    checked: { table: { disable: true } },
    disabled: { table: { disable: true } },
    id: { table: { disable: true } },
    label: { table: { disable: true } },
    name: { table: { disable: true } },
    tooltip: { table: { disable: true } },
    value: { table: { disable: true } },
  },
  args: {
    checked: false,
    disabled: false,
    id: '',
    label: 'Switch label',
    name: 'switch-name',
    tooltip: '',
    value: '',
  },
  decorators: [
    (story: PartialStoryFn, { args: { tooltip } }: StoryContext) =>
      html`
        <style type="text/css">
          #root,
          .docs-story {
            padding-top: ${tooltip ? '2rem' : ''};
          }
        </style>
        ${story()}
      `,
  ],
  parameters: {
    controls: {
      hideNoControlsWarning: true,
      sort: 'requiredFirst',
    },
  },
  title: 'Components/Switch/',
};

interface Story {
  checked: Switch['checked'];
  disabled: Switch['disabled'];
  id: string;
  label: string;
  name: Switch['name'];
  tooltip: Switch['tooltip'];
  value: Switch['value'];
}

export const story = ({ checked, disabled, id, label, name, tooltip, value }: Partial<Story>) => html`
  <abds-switch
    checked="${ifDefined(checked || undefined)}"
    disabled="${ifDefined(disabled || undefined)}"
    id="${ifDefined(id || undefined)}"
    name="${ifDefined(name || undefined)}"
    tooltip="${ifDefined(tooltip || undefined)}"
    value="${ifDefined(value || undefined)}"
  >
    ${label}
  </abds-switch>
`;

export default { meta, story };
